"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", " !important;\n\tborder: ", " solid ", ";\n\tpadding: ", " ", ";\n\tbackground: ", ";\n\tposition: relative;\n\tmargin-top: ", ";\n\tborder-radius: ", ";\n\ttext-align: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var ValidationWrapper = _styledComponents.default.p(_templateObject(), _colors.default.error, _vars.default.borderWidth, _colors.default.error, _spacing.default.s1, _spacing.default.s2, _colors.default.white, _spacing.default.s1, _vars.default.borderRadius, function (props) {
  return props.center ? 'center' : 'left';
});

ValidationWrapper.displayName = 'ValidationWrapper';

var Validation = function Validation(_ref) {
  var visible = _ref.visible,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["visible", "children"]);

  if (visible && typeof children === 'boolean') {
    // eslint-disable-next-line no-console
    console.warn('validation routines should supply string as return value when an error is shown');
  }

  if (visible) {
    return _react.default.createElement(ValidationWrapper, props, children);
  }

  return null;
};

Validation.displayName = 'Validation';
Validation.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool]).isRequired,
  visible: _propTypes.bool
};
Validation.defaultProps = {
  visible: false
};
var _default = Validation;
exports.default = _default;